import { EmbedContainer } from './Container';
import { SpotterEmbed } from '@thoughtspot/visual-embed-sdk/react';
import { NoObjectSelected } from './NoObjectSelected';
import { useEffect, useState } from 'react';
import { useVariable } from 'context/ThemeContext';
import { SPOTTER_EMBED_FEATURE_FLAGS } from '../../constants';

const SpotterEmbedBase = ({ embedRef, variables, embedSelections, setEmbedSelections }: any) => {
  const dataSource = embedSelections?.dataSource;
  const {
    state: { dataSourceList },
  } = useVariable();
  const [spotterData, setSpotterData] = useState(null);
  const [showNoObjectSelected, setShowNoObjectSelected] = useState(false);
  useEffect(() => {
    const defaultDataSource = dataSourceList?.length > 0 ? dataSourceList[0]?.id : '';
    if (!dataSource && defaultDataSource && setEmbedSelections) {
      setSpotterData(defaultDataSource);
      setEmbedSelections({ dataSource: defaultDataSource });
    } else if (dataSource && setEmbedSelections) {
      setSpotterData(dataSource);
      setEmbedSelections({ dataSource });
    }
    return () => {
      setSpotterData(null);
      setEmbedSelections({ dataSource: null, answerId: null });
    };
  }, [dataSource, dataSourceList, setEmbedSelections]);

  useEffect(() => {
    if (!spotterData) {
      const timer = setTimeout(() => {
        setShowNoObjectSelected(true);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [spotterData]);

  return spotterData ? (
    <SpotterEmbed
      frameParams={{
        height: '100%',
      }}
      ref={embedRef}
      className="embed-content"
      disabledActionReason="Spotter Embed"
      worksheetId={spotterData}
      {...SPOTTER_EMBED_FEATURE_FLAGS}
      customizations={{
        style: {
          customCSS: {
            variables: variables,
          },
        },
      }}
    />
  ) : showNoObjectSelected ? (
    <NoObjectSelected
      title="No Data Source selected"
      description="Select a Data Source to see Spotter"
    />
  ) : null;
};

export const SpotterEmbedPage = (props) => {
  return <EmbedContainer EmbedComponent={SpotterEmbedBase} {...props} />;
};
